/**
 * GL220-11 (glasronde 0.9.218): het Code-scherm in de taal van het scherm.
 *
 * Gemeten op Franks machine (30 oktober, alleen gelezen): zijn vier werkruimtes heten "Untitled workspace" (zo
 * gemaakt door een oudere versie) en de geleerde regel staat als "hallo.py runs with python" opgeslagen; die zin
 * schrijft `backend/services/memory.py` voor het model. De GEGEVENS blijven zoals ze zijn; dit vertaalt bij het
 * TONEN. Zelfde standaardnamen als `backend/services/herkomst.py` (STANDAARDNAMEN).
 *
 * PUUR: `t` komt van de aanroeper.
 */

const STANDAARDNAMEN = new Set(["untitled", "untitled workspace", "naamloze werkruimte"]);

/** De naam van een werkruimte; de standaardnaam in de taal van het scherm. */
export function werkruimteNaam(naam, t) {
  return STANDAARDNAMEN.has(String(naam || "").trim().toLowerCase()) ? t("Naamloze werkruimte") : naam;
}

const DRAAIT = /^(.+?) runs with (.+?)(?: and needs (.+))?$/;
const NETWERK = /^(.+?) needs network access to (.+)$/;

/** Een geleerde regel van de agent in de taal van het scherm; een onbekende vorm blijft staan. */
export function geleerdeRegel(tekst, t) {
  const s = String(tekst || "");
  let m = DRAAIT.exec(s);
  if (m) {
    return m[3]
      ? t("{pad} draait met {taal} en heeft {hosts} nodig", { pad: m[1], taal: m[2], hosts: m[3] })
      : t("{pad} draait met {taal}", { pad: m[1], taal: m[2] });
  }
  m = NETWERK.exec(s);
  if (m) return t("{pad} heeft netwerktoegang nodig tot {hosts}", { pad: m[1], hosts: m[2] });
  return s;
}
